export default "__VITE_ASSET__d6dda70d__"